import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { ICollectionsState } from ".";

export interface ICollectionItem {
    partNumber: number;
    count: number;
}

export enum PrizeType {
    File = 1,
    RareTicket = 2,
    EpicTicket = 3,
    LegendaryTicket = 4,
    Fragment = 5,
}

export interface IUserCollection {
    collectionId: number;
    name: string;
    items: ICollectionItem[];
    type: PrizeType;
}

export interface IGetCollectionsResponse {
    collections: IUserCollection[],
};

export const getCollections = createAsyncThunk<IGetCollectionsResponse>(
    'getCollections',
    async () => await api.collections.get()
);

const getCollectionsHandler = (builder: ActionReducerMapBuilder<ICollectionsState>) => {
    builder
        .addCase(getCollections.pending, (state: ICollectionsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getCollections.fulfilled, (state: ICollectionsState, action: PayloadAction<IGetCollectionsResponse>) => {
            state.loading = false;
            state.items = action.payload?.collections ?? [];
        })
        .addCase(getCollections.rejected, (state: ICollectionsState) => {
            state.loading = false;
            state.error = 'Unable to get collections';
        });
};

export default getCollectionsHandler;